import { Typography } from '@mui/material'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import { Plus } from 'mdi-material-ui'
import { useEffect, useState } from 'react'
import TableActivity from 'src/views/activity/TableActivity'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import BoxWrapper from '../../styles/BoxWrapper'
import DialogActivity from '../../views/activity/DialogActivity'

const ActivityList = () => {
    const [reload, setReload] = useState(0)
    const [show, setShow] = useState(false)
    const [activityID, setActivityID] = useState(0)

    useEffect(() => {
        !show && setActivityID(0)
    }, [show])

    useEffect(() => {
        activityID > 0 && setShow(true)
    }, [activityID])

    return (
        <Page title="Coupon">
            <Grid container spacing={6}>
                <PageHeader
                    title={
                    <Typography variant='h5' color='#666CFF'>
                        활동 이력
                    </Typography>
                    }                    
                />
                <BoxWrapper>
                    <Button variant='contained' startIcon={<Plus />} onClick={() => {setShow(true)}} >등록</Button>
                </BoxWrapper>
                <DialogActivity show={show} setShow={setShow} setReload={setReload} activityID={activityID} />
                <Grid item xs={12}>
                    <TableActivity reload={reload} setReload={setReload} setActivityID={setActivityID} />
                </Grid>
            </Grid>
        </Page>
    )
}

export default ActivityList